export default __webpack_public_path__ + "static/media/qrcode-bg.68305b0b.png";